import { PreloaderService } from './../../../common/services/preloader/preloader.service';
import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put, select } from 'redux-saga/effects';
import {
  FETCH_DESTINATION_DETAIL_SUCCEEDED,
  FETCH_DESTINATION_DETAIL_REQUESTED,
  SELECT_DESTINATION_TYPE,
  FETCH_DESTINATION_TYPE_SUCCEEDED_WITHOUR_PREFILL,
  UPDATE_DESTINATION_REQUESTED,
  FETCH_ALL_DESTINATION_TYPE_SUCCEEDED,
  UPDATE_DESTINATION_SUCCEEDED
} from './edit.action';
import { ApiService } from '../../../api/api.service';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { Router } from '@angular/router';

function* getDestination(action) {
  try {
    const api = AppInjector.get(ApiService);
    let destination = yield api.destination.getItemById(action.data).toPromise();
    yield put({ type: FETCH_DESTINATION_DETAIL_SUCCEEDED, data: destination });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDestinationRequested() {
  yield takeEvery(FETCH_DESTINATION_DETAIL_REQUESTED, getDestination);
}

function* getDestinatoionTypes(action) {
  try {
    const api = AppInjector.get(ApiService);
    let results = yield api.destinationType.list().toPromise();
    yield put({ type: FETCH_ALL_DESTINATION_TYPE_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDestinationSUCCEEDED() {
  yield takeEvery(FETCH_DESTINATION_DETAIL_SUCCEEDED, getDestinatoionTypes);
}

function* updateDestination(action) {
  AppInjector.get(PreloaderService).show();
  try {
    const api = AppInjector.get(ApiService);
    const notify = AppInjector.get(NotificationService);
    let result = yield api.destination.update(action.data).toPromise();
    AppInjector.get(PreloaderService).hide();
    notify.show('success', 'Destination is updated', 3000);
    yield put({ type: UPDATE_DESTINATION_SUCCEEDED, data: result });
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateDestinationRequested() {
  yield takeEvery(UPDATE_DESTINATION_REQUESTED, updateDestination);
}

function* redirect(action) {
  AppInjector.get(Router).navigate(['destination']);
}

function* watchUpdateDestinationSUCCEEDED() {
  yield takeEvery(UPDATE_DESTINATION_SUCCEEDED, redirect);
}

export default [watchDestinationRequested, watchDestinationSUCCEEDED, watchUpdateDestinationRequested, watchUpdateDestinationSUCCEEDED];
